import React from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { patchLocationMarker, deleteLocationMarker } from 'redux/location-links/actions';
import { setLastPatchedId } from 'redux/common/actions';

import CommonInputField from 'components/elements/inputs/CommonInputField';

import './LocationLinkMarkerItem.css';


function LocationLinkMarkerItem(props) {
  const {
    marker,
    patchLocationMarker,
    deleteLocationMarker,
    patchLocationMarkerError,
    setLastPatchedId,
    linkItem,
    lastPatchedId,
  } = props;
  const { t } = useTranslation();

  const validation = value => {
    if (!value) {
      return t("Marker title should not be empty");
    }
    if (value) {
      if (value.length > 128) {
        return t("Ensure this field has no more than 128 characters");
      }
    }
    return null;
  };

  return (
    <div className="location-link-marker-item__component">
      <div className="field-container">
        <CommonInputField
          key={`location-link-marker-input-key-${marker.id}`}
          editIcon
          initialValue={marker.title}
          executedFunction={value => {
            const form = new FormData();
            form.append('title', value);
            patchLocationMarker(marker.id, form);
            setLastPatchedId(marker.id);
          }}
          serverErrors={
            lastPatchedId === marker.id &&
            patchLocationMarkerError &&
            patchLocationMarkerError.title
          }
          validationFunction={validation}
        />
      </div>

      {/* Delete Button */}
      {linkItem.markers && linkItem.markers.length > 1 &&
        <div className="delete-button-container">
          <div
            className="delete-button"
            onClick={() => deleteLocationMarker(marker.id)}
            role="button"
            tabIndex={-1}
          />
        </div>
      }
    </div>
  );
}

LocationLinkMarkerItem.propTypes = {
  patchLocationMarker: PropTypes.func.isRequired,
  deleteLocationMarker: PropTypes.func.isRequired,
  setLastPatchedId: PropTypes.func.isRequired,
  marker: PropTypes.object.isRequired,
  patchLocationMarkerError: PropTypes.object,
  linkItem: PropTypes.object.isRequired,
  lastPatchedId: PropTypes.number,
};

LocationLinkMarkerItem.defaultProps = {
  patchLocationMarkerError: null,
  lastPatchedId: null,
};

const mapStateToProps = state => (
  {
    patchLocationMarkerError: state.locationLinksReducer.patchLocationMarkerError,
    lastPatchedId: state.commonReducer.lastPatchedId,
  }
);

export default connect(
  mapStateToProps,
  {
    patchLocationMarker,
    deleteLocationMarker,
    setLastPatchedId,
  },
)(LocationLinkMarkerItem);
